<template>
  <a-row :gutter="10">
    <a-col :md="24" :sm="24">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表口径')">
                    <a-select v-model="queryParam.meterCaliber" :placeholder="$t('表口径')">
                        <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                          DN{{data.mtCaliber}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表类型')">
                    <a-select v-model="queryParam.meterType" :placeholder="$t('请选择表类型')">
                        <a-select-option v-for="data in meterTypeList" :key="data.id" :value="data.id">
                            {{data.mtName}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="mtCaliber"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :loading="loading"
            class="j-table-force-nowrap"
            >
              <a slot="totalMeterCount" slot-scope="text,record" @click="skipPage({mtCode: record.mtCodeKeyId})">{{ text }}</a>
              <a slot="openedMeterCount" slot-scope="text,record" @click="skipPage({mtCode: record.mtCodeKeyId,mtState: 1})">{{ text }}</a>
          </a-table>
        </div>
        <div>
          <div id="mtTypeChart" style="width:100%;height:400px;"></div>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,putAction } from '@/api/manage'
  import { listSize,filterObj } from '@/utils/util'
  import * as echarts from 'echarts'

  export default {
    name: 'meterinfoAnalysisCountByMeterType',
    mixins:[JeecgListMixin],
    components: {
    },
    data () {
      return {
        description: this.$t('表具统计'),
        url: {
          list: "/jeecg-charge/meter/waterAnalysis/meterinfoAnalysisCountByMeterType",
          meterTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
        },
        meterTypeList:[],  //表类型
        userCaliberList:[],  // 表口径
      }
    },
    created() {
        this.queryMeterTypeList()
        this.queryUserCaliberList()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title:this.$t('表类型'),
            align:"center",
            dataIndex:'mtName',
            customRender:(t,r,index) => {
              return t?t: '--';
            },
          },
          {
            title:this.$t('表具总数'),
            align:"center",
            dataIndex:'totalMeterCount',
            scopedSlots: { customRender: 'totalMeterCount' },
          },
          {
            title:this.$t('建档数'),
            align:"center",
            dataIndex:'openedMeterCount',
            scopedSlots: { customRender: 'openedMeterCount' },
          }
        ]
      },
    },
    methods: {
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        putAction(this.url.list, params).then((res) => {
          console.log(res.result.records);
          if (res.success) {
            this.dataSource = res.result;
            let meterCount = 0;
            let userCount = 0;
            for(let i =0;i<res.result.length;i++) {
                meterCount+=res.result[i].totalMeterCount
                userCount+=res.result[i].openedMeterCount
            }
            this.initChart(res.result);
            this.dataSource.push({mtName: this.$t('总计'),mtCode: '总计',openedMeterCount: userCount,totalMeterCount: meterCount})

          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      queryMeterTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.meterTypeList, params).then((res) => {
          if(res.success){
            this.meterTypeList = res.result.records;
          }
        }) 
      },
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      skipPage(obj) {
        let param = {...obj}
        if(param.mtCode === '总计') {
          delete param['mtCode']
        }
        this.$router.push({ 
          // name: "meterinfoList",
          name: 'meterManagement-meterinfoList',
          params:param
        })
      },
      initChart(data) {
        let myChart = echarts.init(document.getElementById('mtTypeChart'));
        let [xData, yData1, yData2] = [[],[],[]];
        data.map(item=>{ 
          xData.push(item.mtName);
          yData1.push(item.totalMeterCount);
          yData2.push(item.openedMeterCount);
        })
        let option = {
          title: {
            text: this.$t('表类型统计'),
            top: 20
          },
          color: ['#248ff7','#8bd46e'],
          legend: {
            data: [this.$t('表具总数'),this.$t('建档数')],
            top: 20
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          xAxis: {
            data: xData
          },
          yAxis: {},
          series: [{
            name: this.$t('表具总数'),
            data: yData1,
            type: 'bar',
            barWidth: 30
          },{
            name: this.$t('建档数'),
            data: yData2,
            type: 'bar',
            barWidth: 30
          }]
        };
        myChart.setOption(option);
        window.onresize = function () {
          myChart.resize();
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>